import { UsersIcon as PhosphorUsersIcon } from "@phosphor-icons/react/dist/ssr/Users";

import { createAppIcon } from "@/components/createAppIcon";

export const GroupIcon = /* @__PURE__ */ createAppIcon(PhosphorUsersIcon);
